import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Container,
  Divider,
  FormHelperText,
  Grid,
  IconButton,
  Stack,
  Tab,
  TextField,
  Typography,
  styled,
} from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';

import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';

import Page from '../../components/Page';
import Image from '../../components/Image';
import { useSelector, useDispatch } from '../../redux/store';
// import { openConfirm } from '../../redux/slices/confirm';
import useResponsive from '../../hooks/useResponsive';
// import { isHTML, sanitizeHtml } from '../../utils/formatString';
import useLocales from '../../hooks/useLocales';
import useAuth from '../../hooks/useAuth';
import { getUserMemberBalance, getPromotions } from '../../redux/slices/lookup';
import { openLoginSignup } from '../../redux/slices/authPages';

import CustomModal from '../../components/CustomModal';

import conObj, { showResponseError } from '../../utils/connection-assistant';
import useTabs from '../../hooks/useTabs';
import { InputContainer, StyledInput, ThemeButton } from '../../layouts/GlobalStyles';
import { fNumber } from '../../utils/formatNumber';
import Iconify from '../../components/Iconify';

const BannerImage = styled(Image)(({ theme }) => ({
  borderRadius: '10px 10px 0px 0px',
}));

const BannerBottomContainer = styled(Stack)(({ hasImage }) => ({
  borderRadius: '0px 0px 10px 10px',
  // backgroundColor: '#353347',
  position: 'relative',
  zIndex: 1,
  marginBottom: '0 !important',
  padding: '.5rem .75rem .375rem',
}));

const BannerBottomContainerTitle = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 500,
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  marginBottom: 0,
});

const BannerBottomContainerSubtitle = styled(Typography)({
  fontSize: 12,
  fontWeight: 300,
  lineHeight: '12px',
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  marginBottom: 0,
});

const MoreInfoButton = styled(Typography)(({ theme }) => ({
  background: 'linear-gradient(98deg, #ff7f7f -17.16%, #7C0001 91.36%) text',
  color: 'transparent',
  whiteSpace: 'nowrap',
  fontWeight: 700,
  lineHeight: '18px',
  fontSize: '.75rem',
  cursor: 'pointer',
  borderBottom: '1px solid red',
}));

const ApplyNowButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(to bottom, #EB0101, #7C0001)',
  cursor: 'pointer',
  fontSize: '.75rem',
  padding: '5px 10px',
  margin: 0,
  width: 'auto',
  color: '#fff',
  flex: 'unset',
  borderRadius: 7
}));

const ButtonText = styled(Typography)(({ theme }) => ({
  // color: '#fff',
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 500,
  textAlign: 'center',
  textShadow: '0px 1px 2px black',
}));

// const ClaimButton = styled(Button)(({ theme }) => ({
//   background: 'linear-gradient(0deg, #adde2a, #87e632)',
//   padding: 12,
//   width: '75%',
//   marginLeft: 'auto !important',
//   marginRight: 'auto !important',
// }));

// const ClaimButtonText = styled(Typography)(({ theme }) => ({
//   color: 'white',
//   fontWeight: 600,
//   fontSize: 15,
//   textShadow: '0px 1px 2px black',
// }));

const ModalTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontWeight: 600,
  fontSize: 20,
}));

const ModalSubTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: 15,
}));

const ModalButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(to bottom, #FFE11E, #F19119)',
  padding: '10px 3rem',
  width: 'auto',
  marginLeft: 'auto !important',
  marginRight: 'auto !important',
  marginTop: 2,
  display: 'block',
}));

const ModalButtonText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: 600,
  fontSize: 15,
  textShadow: '0px 1px 2px black',
}));

const InputBox = styled(Stack)(({ theme }) => ({
  background: '#2C0202',
  border: '1px solid #840000',
  padding: '.375rem .75rem',
  borderRadius: '.25rem',
  cursor: 'pointer',
  alignItems: 'center',
}));

const StyledTab = styled(Tab)(() => ({
  height: 30,
  borderRadius: 20,
  minHeight: 'unset',
  padding: 4,
  fontSize: '.875rem',
  fontWeight: 700,
  display: 'flex',
  // flex: 1,
  margin: '0 !important',
}));

const _openConfirm = {
  open: false,
  title: 'Claim bonus?',
  subTitle: 'Bonus to claim now!',
  onConfirm: null,
};

const Promotion = () => {
  const { isAuthenticated } = useAuth();

  const { currentTab, setCurrentTab } = useTabs('All');

  const { promotions, angPauPromos, memberBalance } = useSelector((x) => x.lookup);

  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const { translate } = useLocales();

  const navigate = useNavigate();

  const isDesktop = useResponsive('up', 'lg');

  const [openConfirm, setOpenConfirm] = useState(_openConfirm);

  const [isSubmittin, setIsSubmitting] = useState(false);

  const [categs, setCategs] = useState([]);

  const [singleAngpaoPromotion, setSingleAngpaoPromotion] = useState(null);

  const [promoCode, setPromoCode] = useState('');

  useEffect(() => {
    getPromotions();

    if (angPauPromos?.data?.length) {
      setSingleAngpaoPromotion(angPauPromos?.data[0]?.id);
    }
  }, []);

  useEffect(() => {
    let tabsByGroup = [];

    if (promotions?.data?.length) {
      tabsByGroup = Object.values(promotions?.groupings);
    }

    setCategs(tabsByGroup);
  }, [promotions]);

  const filteredTabs = useMemo(() => {
    return [translate('all'), ...categs];
  }, [categs]);

  // const selectedTab = useMemo(() => {
  //   const found = filteredTabs.find((x) => x.name === currentTab);
  //   if (found?.component) return found.component;

  //   return '';
  // }, [currentTab, filteredTabs]);

  const selectedTabData = useMemo(() => {
    if (promotions?.data?.length) {
      if (currentTab === 'All') {
        return promotions?.data;
      }
      const filtered = promotions?.data?.filter((p) => {
        return Object.values(p?.grouping).some((value) => value === currentTab);
      });

      return filtered || [];
    }

    return [];
  }, [currentTab]);

  const handleClaimBonus = async (id) => {
    setIsSubmitting(true);
    try {
      await conObj.post('transactions/manual_claim_bonus.json', {
        'transaction-promotion_id': id,
      });

      getUserMemberBalance();

      getPromotions();

      setIsSubmitting(false);

      setOpenConfirm(_openConfirm);

      enqueueSnackbar(translate('bonus_claimed'));
    } catch (error) {
      setIsSubmitting(false);
      enqueueSnackbar(error?.message, { variant: 'error' });
    }
  };

  const submitPromoCode = async () => {
    try {
      if (!isAuthenticated) return;
      if (!promoCode) throw new Error(translate('x_is_required', { x: translate('promo_code') }));

      setIsSubmitting(true);

      const response = await conObj.post(`/transactions/unlock_promotion/${promoCode}.json`);

      const _bonusAmount = response.data?.data?.bonusAmount;

      if (response.data?.data?.msg) {
        enqueueSnackbar(response.data?.data?.msg);
      } else if (_bonusAmount) {
        enqueueSnackbar(translate('x_claimed', { x: `${memberBalance?.currencyCode} ${fNumber(_bonusAmount)}` }));
      } else {
        enqueueSnackbar('bonus_unlocked');
      }

      getUserMemberBalance();

      getPromotions();

      setPromoCode('');
    } catch (error) {
      console.log(error);

      showResponseError(error, enqueueSnackbar);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Page title="Promotion">
      <Container sx={{ px: '0 !important' }}>
        <Stack direction="row" sx={{ background: '#2C0202', px: '.5rem', py: '.75rem' }}>
          <Iconify
            onClick={() => navigate(-1)}
            icon={'ic:twotone-arrow-back'}
            sx={{ width: '26px', height: '26px', color: '#fff', cursor: 'pointer' }}
          />
          <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: '#fff', textAlign: 'center', flex: 1 }}>
            {translate('promotion')}
          </Typography>
        </Stack>
        {isAuthenticated ? (
          <Box sx={{ mt: '1rem', mx: '10px', maxWidth: { xs: '100%', md: '75%', lg: '50%' } }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Box sx={{ flex: 1 }}>
                <InputBox direction="row">
                  <StyledInput
                    fullWidth
                    value={promoCode}
                    placeholder={translate('enter_promo_code')}
                    onChange={(e) => setPromoCode(e.target.value)}
                    sx={{ height: 'unset' }}
                  />
                  {promoCode ? (
                    <IconButton onClick={() => setPromoCode('')} sx={{ p: 0 }}>
                      <Iconify icon={'uil:times'} />
                    </IconButton>
                  ) : null}
                </InputBox>
              </Box>

              <ThemeButton
                sx={{ whiteSpace: 'nowrap', height: 'unset', fontSize: '0.8rem' }}
                disabled={!promoCode || isSubmittin}
                loading={isSubmittin}
                onClick={() => submitPromoCode()}
              >
                {translate('apply_code')}
              </ThemeButton>
            </Box>
          </Box>
        ) : (
          ''
        )}

        <TabContext value={currentTab}>
          <TabList
            onChange={(event, newValue) => {
              setCurrentTab(newValue);
            }}
            aria-label="referral tabs"
            sx={{
              minHeight: 'unset',
              margin: '0 !important',
              marginTop: '10px !important',
              // borderBottom: '1px solid #fff',
              paddingX: 2,
            }}
            variant="scrollable"
            TabIndicatorProps={{
              style: {
                // borderBottomWidth: 2,
                backgroundColor: 'transparent !important',
                display: 'none',
              },
            }}
          >
            {filteredTabs.map((x, idx) => (
              <StyledTab
                key={idx}
                label={x}
                value={x}
                sx={{
                  background: currentTab === x ? '#FB0500' : 'transparent',
                  // color: '#fff',
                  // fontWeight: 400,
                  // fontSize: '15px',
                  // minWidth: '146px',
                  // paddingX: 1,
                  // marginRight: '5px !important',
                  // background: currentTab === x ? 'linear-gradient(180deg, #FEE504 0%, #ED7E40 100%)' : 'transparent',
                  // border: currentTab === x ? '1px solid #FFF1B9' : '1px solid #fff',
                  // borderBottom: 'none',
                }}
              />
            ))}
          </TabList>
        </TabContext>
        <Box sx={{ px: '1rem', pt: '26px', pb: '50px' }}>
          <Grid
            container
            spacing={'13px'}
            sx={{
              background: 'linear-gradient(0deg, #790000 -5.86%, #EE0000 104.05%)',
              border: '1px solid #840000',
              borderRadius: '7px',
              py: '.875rem',
              px: '.75rem',
              width: '100% !important',
              ml: 'unset !important'
            }}
          >
            {(selectedTabData.length > 0 ? selectedTabData : promotions?.data)?.map((x, idx) => (
              <Grid
                item
                xl={4}
                lg={4}
                md={4}
                sm={6}
                xs={12}
                key={idx}
                // mb={(!isDesktop && x?.banner_mobile_url) || x?.banner ? 15 : 0}
                sx={{ height: '100%', pl: { md: '13px !important', sm: '0px !important', xs: '0px !important' } }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    height: '100%',
                    background: '#2C0202',
                    boxShadow: 'rgba(255, 255, 255, 0.25) 0px 0px 8px 0px',
                    borderRadius: '7px',
                  }}
                >
                  {(!isDesktop && x?.banner_mobile_url) || x?.banner ? (
                    <BannerImage
                      src={!isDesktop && x?.banner_mobile_url ? x?.banner_mobile_url : x?.banner}
                      alt="Promo"
                    />
                  ) : (
                    <></>
                  )}
                  <BannerBottomContainer
                    direction="column"
                    spacing={1}
                    hasImage={(!isDesktop && x?.banner_mobile_url) || x?.banner}
                  >
                    <Container sx={{ px: '0px !important' }}>
                      <BannerBottomContainerTitle gutterBottom>{x?.title}</BannerBottomContainerTitle>
                      {/* <BannerBottomContainerSubtitle gutterBottom>{x?.sub_title || ''}</BannerBottomContainerSubtitle> */}
                    </Container>
                    <Divider sx={{ borderBottomWidth: '2px' }} />
                    <Stack direction={'row'} alignItems={'center'} spacing={2}>
                      {x?.is_manual_claimable && (
                        <ApplyNowButton
                          onClick={() => {
                            if (x?.id === singleAngpaoPromotion) {
                              navigate('/angpau');
                              return;
                            }

                            if (!isAuthenticated) dispatch(openLoginSignup());
                            if (x?.is_claimable_now && isAuthenticated) {
                              setOpenConfirm({
                                open: true,
                                title: `${translate('claim_bonus')}?`,
                                subTitle: x?.title || '',
                                onConfirm: () => handleClaimBonus(x?.id),
                              });
                            }
                          }}
                          disabled={!x?.is_claimable_now}
                          sx={{
                            opacity: x?.is_claimable_now ? 1 : 0.2,
                          }}
                        >
                          {translate('apply_now')}
                        </ApplyNowButton>
                      )}
                      <div style={{ flex: 1 }} />
                      <MoreInfoButton
                        onClick={() =>
                          x?.id === singleAngpaoPromotion ? navigate('/angpau') : navigate(`/promotion/view/${x?.id}`)
                        }
                      >
                        {translate('condition')}
                      </MoreInfoButton>
                    </Stack>
                    {/* {x?.is_manual_claimable && (
                      <ClaimButton
                        onClick={() => {
                          if (!isAuthenticated) dispatch(openLoginSignup());
                          if (x?.is_claimable_now && isAuthenticated) {
                            setOpenConfirm({
                              open: true,
                              title: `${translate('claim_bonus')}?`,
                              subTitle: x?.title || '',
                              onConfirm: () => handleClaimBonus(x?.id),
                            });
                          }
                        }}
                        disabled={!x?.is_claimable_now}
                        sx={{
                          opacity: x?.is_claimable_now ? 1 : 0.2,
                        }}
                      >
                        <ClaimButtonText>
                          {x?.is_claimable_now ? translate('claim_bonus') : translate('claimed')}
                        </ClaimButtonText>
                      </ClaimButton>
                    )} */}
                  </BannerBottomContainer>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>

      {openConfirm?.open && (
        <CustomModal
          open={openConfirm?.open}
          onClose={() => setOpenConfirm(_openConfirm)}
          isBackdropClosable={false}
          // sx={{ overflow: 'hidden' }}
        >
          <Box sx={{ p: 2 }}>
            <ModalTitle>{openConfirm?.title}</ModalTitle>
            <ModalSubTitle>{openConfirm?.subTitle}</ModalSubTitle>
            <ModalButton onClick={openConfirm?.onConfirm} disabled={isSubmittin}>
              <ModalButtonText>{translate('confirm')}</ModalButtonText>
            </ModalButton>
          </Box>
        </CustomModal>
      )}
    </Page>
  );
};

export default Promotion;
